// extracted by mini-css-extract-plugin
export default {"loadingModal":"_1HfDEGSIujQLVQCvo2f5Jv","spin":"_3dFOd-2afeWhp3i1GRYCi5"};